import { render, staticRenderFns } from "./sticker-model.vue?vue&type=template&id=d4d40b94&"
import script from "./sticker-model.vue?vue&type=script&lang=js&"
export * from "./sticker-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports